var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.037,
    height: 22.037,
    viewBox: "0 0 22.037 22.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#25824a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.301 7.117)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M134.378,165.642a.893.893,0,0,0-1.263-.033l-5.7,5.409-2.72-2.793a.893.893,0,0,0-1.28,1.247l3.335,3.424a.894.894,0,0,0,1.255.025l6.343-6.016A.893.893,0,0,0,134.378,165.642Z",
    transform: "translate(-123.158 -165.364)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.019,0A11.019,11.019,0,1,0,22.037,11.019,11.031,11.031,0,0,0,11.019,0Zm0,20.25a9.232,9.232,0,1,1,9.232-9.232A9.242,9.242,0,0,1,11.019,20.25Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2fb9e075b5f4a1aa337a7af8d4ee98aa.svg";
export { ForwardRef as ReactComponent };